// extracted by mini-css-extract-plugin
module.exports = {"searchLogo":"styles_searchLogo__Z7SaN","logoContainer":"styles_logoContainer__A7b0y"};